import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IOrder } from '@/shared/model/order.model';
import { buildURLQueryOpts } from '@/shared/query/query';

const baseApiUrl = 'api/v1/orders';

export default class OrderService {
  public find(id: number): Promise<IOrder> {
    return new Promise<IOrder>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any, searchQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}&${buildURLQueryOpts(searchQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveAssignableToProduct(productId: number, productTypeId): Promise<any> {
    return axios.get(`${baseApiUrl}/assignableToProduct?productId=${productId}&productTypeId=${productTypeId}`);
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IOrder): Promise<IOrder> {
    return new Promise<IOrder>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public createOrderItem(entity: IOrder, action?: string): Promise<IOrder> {
    return new Promise<IOrder>((resolve, reject) => {
      const { id } = entity;
      const actionUrl = action ? `/${action}` : ``;
      const entityParamsWithoutId = (({ id, ...entity }) => entity)(entity);
      axios
        .post(`${baseApiUrl}/${id}${actionUrl}`, entityParamsWithoutId)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IOrder, action?: string): Promise<IOrder> {
    const { id } = entity;
    const actionUrl = action ? `/${action}` : ``;

    return new Promise<IOrder>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${id}${actionUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
